import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgStethoscope = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.125 3.875H11.375C11.7065 3.875 12.0245 4.0067 12.2589 4.24112C12.4933 4.47554 12.625 4.79348 12.625 5.125V10.125C12.625 11.4511 12.0982 12.7229 11.1605 13.6605C10.2229 14.5982 8.95108 15.125 7.625 15.125C6.29892 15.125 5.02715 14.5982 4.08947 13.6605C3.15178 12.7229 2.625 11.4511 2.625 10.125V5.125C2.625 4.79348 2.7567 4.47554 2.99112 4.24112C3.22554 4.0067 3.54348 3.875 3.875 3.875H5.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.125 2.625V5.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.125 2.625V5.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.375 10.125C16.375 10.788 16.6384 11.4239 17.1072 11.8928C17.5761 12.3616 18.212 12.625 18.875 12.625C19.538 12.625 20.1739 12.3616 20.6428 11.8928C21.1116 11.4239 21.375 10.788 21.375 10.125C21.375 9.46196 21.1116 8.82607 20.6428 8.35723C20.1739 7.88839 19.538 7.625 18.875 7.625C18.212 7.625 17.5761 7.88839 17.1072 8.35723C16.6384 8.82607 16.375 9.46196 16.375 10.125V10.125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.625 15.125V15.75C7.625 17.2418 8.21763 18.6726 9.27252 19.7275C10.3274 20.7824 11.7582 21.375 13.25 21.375C14.7418 21.375 16.1726 20.7824 17.2275 19.7275C18.2824 18.6726 18.875 17.2418 18.875 15.75V12.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgStethoscope.displayName = 'SvgStethoscope';
export default SvgStethoscope;
